import { object, SchemaOf } from 'yup';
import { validateEmail, validatePassword } from '../../../lib/utils/inputValidation';
import { LoginFormFields, LoginSchema } from '../types';

export const loginValidation: SchemaOf<LoginSchema>  = object().shape({
  [LoginFormFields.email]: validateEmail.required('Email is required'),
  [LoginFormFields.password]: validatePassword,
});
